// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1rzl4","inputWrap":"Table_inputWrap__21KlD","col":"Table_col__3lIAP","bmiTooltip":"Table_bmiTooltip__BUQLr"};